import { translate } from 'vue-gettext'

const { pgettext } = translate

const PrintJobStatus = {
    PENDING: {
        value: 1,
        label: pgettext('edge-print-job.status', 'Pending'),
        color: 'warning',
        icon: 'cilClock'
    },
    PRINTING: {
        value: 2,
        label: pgettext('edge-print-job.status', 'Printing'),
        color: 'primary',
        icon: 'cilMediaPlay'
    },
    COMPLETED: {
        value: 3,
        label: pgettext('edge-print-job.status', 'Completed'),
        color: 'success',
        icon: 'cilCheckCircle'
    },
    FAILED: {
        value: 4,
        label: pgettext('edge-print-job.status', 'Failed'),
        color: 'danger',
        icon: 'cilXCircle'
    }
}

export const getPrintJobStatusByValue = (value) => {
    return Object.values(PrintJobStatus).find(s => s.value === value)
}

export const getPrintJobStatusLabel = (status) => {
    const statusObj = getPrintJobStatusByValue(status)
    return statusObj ? statusObj.label : pgettext('edge-print-job.status', 'Unknown')
}

export const getPrintJobStatusColor = (status) => {
    const statusObj = getPrintJobStatusByValue(status)
    return statusObj ? statusObj.color : 'secondary'
}

export const getPrintJobStatusIcon = (status) => {
    const statusObj = getPrintJobStatusByValue(status)
    return statusObj ? statusObj.icon : 'cilHelpCircle'
}

export const getPrintJobStatusOptions = () => {
    return Object.values(PrintJobStatus).map(status => ({
        value: status.value,
        label: status.label
    }))
}

// Active statuses (jobs still in progress)
export const ACTIVE_PRINT_JOB_STATUSES = [
    PrintJobStatus.PENDING.value,
    PrintJobStatus.PRINTING.value
]

// Completed statuses (jobs that are finished)
export const COMPLETED_PRINT_JOB_STATUSES = [
    PrintJobStatus.COMPLETED.value,
    PrintJobStatus.FAILED.value
]

// Helper to get CSS class with text- prefix
export const getPrintJobStatusColorClass = (status) => {
    const color = getPrintJobStatusColor(status)
    return `text-${color}`
}

export default PrintJobStatus
